export default __webpack_public_path__ + "static/media/Rhea_02.59c1d25e.png";